"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var stepComponentLabelPropTypes = {
  step: _propTypes.default.string.isRequired,
  meterValueLabel: _propTypes.default.string.isRequired,
  emailConfirm: _propTypes.default.string.isRequired,
  register: _propTypes.default.string.isRequired,
  done: _propTypes.default.string.isRequired
};
var _default = exports.default = stepComponentLabelPropTypes;